var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LangToggle',{model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})}
var staticRenderFns = []

export { render, staticRenderFns }